import { render, staticRenderFns } from "./needs-child-item.html?vue&type=template&id=3b937d4e&"
import script from "./needs-child-item.js?vue&type=script&lang=js&"
export * from "./needs-child-item.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports